import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Download, Eye, EyeOff, MoveUpRight, Search, X } from "lucide-react";
import { getVehicleClassData } from "../../Utils/helper";
import { Button } from "../../Common/Button";
import CommonTable from "../../Common/CommonTable";
import TextInput from "../../Commponent/TextInput";
import FastagPurchase from "../../Commponent/FastagPurchase";
import Loading from "../../Common/Loading";
import moment from "moment";
import CustomSelectInput from "../../Commponent/SelectInput";
import SideModal from '../../Commponent/SideModal';
import AdminTableModal from '../../Commponent/AdminTableModal';
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { API } from "../../Common/Api";
import { ErrorToast, SuccessToast } from "../../Utils/toast";
import { pageSizeOptions } from "../../Utils/pagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendar from "../../assets/calendar.png";
import downloadingRed from "../../assets/downloadingRed.png";
import CommonModal from "../../Commponent/CommonModal";

function FastagRequest(props) {
  const dispatch = useDispatch();
  const GetFastag = useSelector((state) => state.GetFastag.GetFastagData);
  const GetInventorySummary = useSelector((state) => state.GetInventorySummary.GetInventorySummaryData);
  const DeniedRequest = useSelector((state) => state.DeniedRequest?.DeniedRequestData);
  const GetDistributorNames = useSelector((state) => state.GetDistributorNames?.GetDistributorNamesData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [serialNumber, setSerialNumber] = useState("");
  const [show, setShow] = useState(false);
  const [distributorNames, setDistributorNames] = useState([]);
  const [checkGetDistributorNames, setCheckGetDistributorNames] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [mobileExpandedRows, setMobileExpandedRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedAgentClick, setSelectedAgentClick] = useState(false);
  const [agentModalOpen, setAgentModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [checkGetFastag, setCheckGetFastag] = useState(false);
  const [approvalNote, setApprovalNote] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [isBulkApproving, setIsBulkApproving] = useState(false);
  const [bulkApprovalNote, setBulkApprovalNote] = useState('');
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [checkGetInventorySummary, setCheckGetInventorySummary] = useState(false);
  const [viewDetailsModalOpen, setViewDetailsModalOpen] = useState(false);
  const [viewDetailsItem, setViewDetailsItem] = useState(null);
  const [checkDeniedRequest, setCheckDeniedRequest] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const {
    title = "FASTag Request Summary",
    titleClass = "text-xl font-semibold text-gray-800 mb-[16px] mt-[20px]",
  } = props;

  // Create dynamic summary stats from API data
  const getSummaryStats = () => {
    if (GetInventorySummary?.success && GetInventorySummary?.data) {
      const data = GetInventorySummary.data;
      const total = data.totalFastag?.count || 0;

      const calculatePercentage = (count) => {
        if (!total) return 0;
        const percentage = (count / total) * 100;
        return percentage > 100 ? 100 : percentage;
      };

      return [
        {
          label: "Total FASTag",
          value: total,
          percent: 100,
          color: "#16a34a"
        },
        {
          label: "Distributor Assigned FASTag",
          value: data.distributorAssigned?.count || 0,
          percent: calculatePercentage(data.distributorAssigned?.count || 0),
          color: "#dc2626"
        },
        {
          label: "Dealer Assigned FASTag",
          value: data.dealerAssigned?.count || 0,
          percent: calculatePercentage(data.dealerAssigned?.count || 0),
          color: "#7c3aed"
        },
        {
          label: "Available Stock FASTag",
          value: data.availableStock?.count || 0,
          percent: calculatePercentage(data.availableStock?.count || 0),
          color: "#f59e0b"
        },
      ];
    }
    // Fallback to loading state while API call is in progress
    return [
      { label: "Total FASTag", value: 0, percent: 0, color: "#16a34a" },
      { label: "Distributor Assigned FASTag", value: 0, percent: 0, color: "#dc2626" },
      { label: "Dealer Assigned FASTag", value: 0, percent: 0, color: "#7c3aed" },
      { label: "Available Stock FASTag", value: 0, percent: 0, color: "#f59e0b" },
    ];
  };

  const summaryStats = getSummaryStats();

  const getData = () => {
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      search1: serialNumber,
      search2: selectedAgent,
    }
    setCheckGetFastag(true)
    dispatch(ACTIONS.GetFastagAction(params));
  }

  useEffect(() => {
    getData()
    // Dispatch inventory summary API call
    setCheckGetInventorySummary(true)
    dispatch(ACTIONS.GetInventorySummaryAction());
  }, [itemsPerPage, serialNumber, selectedAgent, currentPage, refreshCount]);

  useEffect(() => {
    setCheckGetDistributorNames(true);
    dispatch(ACTIONS.GetDistributorNamesAction());
  }, []);

  useEffect(() => {
    if (checkGetDistributorNames) {
      if (GetDistributorNames?.status === 200 && GetDistributorNames?.success) {
        setDistributorNames([...new Set(GetDistributorNames.data.map(d => d.username).sort())]);
      }
      setCheckGetDistributorNames(false);
    }
  }, [GetDistributorNames]);

  // Handle responsive column switching
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Set initial state
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    if (checkGetFastag) {
      if (GetFastag?.status == 200 && GetFastag?.success) {
        setTableData(GetFastag?.data.data);
        // Clear selected rows when new data is loaded
        setSelectedRows([]);
      } else {
        const msg = GetFastag?.message;
        if (msg && typeof msg === 'string') ErrorToast(msg);
      }
      setCheckGetFastag(false)
    }
  }, [GetFastag])

  useEffect(() => {
    if (checkGetInventorySummary) {
      if (GetInventorySummary?.status == 200 && GetInventorySummary?.success) {
      } else {
        const msg = GetInventorySummary?.message;
        if (msg && typeof msg === 'string') ErrorToast(msg);
      }
      setCheckGetInventorySummary(false)
    }
  }, [GetInventorySummary]);

  const toggleVisibility = (index, row) => {
    // Always open the modal when eye icon is clicked
    setModalOpen(true);
    setSelectedClass(row);
    setSelectedIndex(index);
  };

  const toggleMobileRow = (index) => {
    setMobileExpandedRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };
  const handleAgentClick = (agentName) => {
    setSelectedAgentClick(agentName);
    setAgentModalOpen(true);
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  // Fixed: Calculate isAllSelected based on current tableData (only for Unassigned rows)
  const unassignedRows = tableData.filter(row => row.status === "Unassigned");
  const isAllSelected = unassignedRows.length > 0 && unassignedRows.every((row) => {
    const rowId = row.id || row._id;
    return selectedRows.includes(rowId);
  });

  // Fixed: Handle individual row selection (only for Unassigned rows)
  const handleRowSelection = (row, isChecked) => {
    // Only allow selection if the row status is "Unassigned"
    if (row.status !== "Unassigned") {
      ErrorToast("Only unassigned requests can be selected for bulk approval");
      return;
    }

    const rowId = row.id || row._id;
    if (isChecked) {
      setSelectedRows((prev) => [...prev, rowId]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== rowId));
    }
  };

  // Fixed: Handle select all functionality (only for Unassigned rows)
  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      // Select only Unassigned rows
      const unassignedIds = unassignedRows.map((row) => row.id || row._id);
      setSelectedRows(unassignedIds);
    } else {
      // Deselect all
      setSelectedRows([]);
    }
  };

  // Function to handle bulk approval
  const handleBulkApprove = async () => {
    if (selectedRows.length === 0) {
      ErrorToast("Please select at least one request to approve");
      return;
    }

    setIsBulkApproving(true);

    try {
      const data = {
        FasTagIds: selectedRows,
        remark: bulkApprovalNote
      };

      const response = await API.ApproveFastag(JSON.stringify(data));

      if (response.status === 200 && response.success) {
        SuccessToast(`${selectedRows.length} requests approved successfully`);
        dispatch({ type: "REFRESH_DATA" });
        // getData(); // redundant now
        setSelectedRows([]); // Clear selections
        setBulkModalOpen(false);
        setBulkApprovalNote('');
      } else {
        ErrorToast(response.message);
      }
    } catch (error) {
      ErrorToast("Failed to approve requests");
    } finally {
      setIsBulkApproving(false);
    }
  };

  // Function to get selected rows data for display
  const getSelectedRowsData = () => {
    return tableData.filter(row => selectedRows.includes(row.id || row._id));
  };

  // Mobile-specific columns - expandable row with all details
  const mobileColumns = [
    {
      label: "Requested By",
      key: "name",
      render: (row, idx) => (
        <div className="w-full bg-white rounded-lg shadow-sm border border-gray-200 ">
          {/* Main row - always visible */}
          <div className="flex items-center justify-between p-4">
            <div className="flex items-center space-x-3 flex-1">
              <input
                type="checkbox"
                checked={selectedRows.includes(row.id || row._id)}
                onChange={(e) => handleRowSelection(row, e.target.checked)}
                className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500"
              />
              <div className="flex-1">
                <div className="font-semibold text-[#1F1715] text-base">{row.user?.username}</div>
                <div className="text-sm text-[#666666] mt-1">{row.user?.email}</div>
                <div className="text-sm text-[#666666] mt-1">{row.user?.mobileNo}</div>
              </div>
            </div>
            <button
              onClick={() => toggleMobileRow(idx)}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors"
            >
              {mobileExpandedRows[idx] ? (
                <ChevronUp className="h-5 w-5" />
              ) : (
                <ChevronDown className="h-5 w-5" />
              )}
            </button>
          </div>

          {/* Expandable content - detailed information */}
          {mobileExpandedRows[idx] && (
            <div className="border-t border-gray-100 px-4 pb-4">
              <div className="space-y-4 mt-4">
                {/* Vehicle Class */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-600">Vehicle Class</span>
                  <div className="flex items-center space-x-2">
                    {(() => {
                      const vehicleClassData = getVehicleClassData(row.vehicleClass);
                      return (
                        <>
                          <img src={vehicleClassData?.tagimage} alt="Tag" className="w-[28px] h-auto" />
                          <span className="text-sm text-gray-800 font-medium">{vehicleClassData?.value}</span>
                          <button
                            onClick={() => toggleVisibility(idx, row)}
                            className="ml-2 p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors"
                          >
                            {modalOpen && selectedIndex === idx ? (
                              <Eye className="h-4 w-4" />
                            ) : (
                              <EyeOff className="h-4 w-4" />
                            )}
                          </button>
                        </>
                      );
                    })()}
                  </div>
                </div>

                {/* Requested Date */}
                <div className="flex items-center justify-between ">
                  <span className="text-sm font-medium text-gray-600">Requested Date</span>
                  <span className="text-sm text-gray-800">{moment(row.createdAt).format("DD MMMM, YYYY, hh:mm A")}</span>
                </div>

                {/* Quantity */}
                <div className="flex items-center justify-between ">
                  <span className="text-sm font-medium text-gray-600">Quantity</span>
                  <span className="text-sm text-gray-800 font-medium">{row.quantity}</span>
                </div>

                {/* Payment Proof */}
                <div className="flex items-center justify-between ">
                  <span className="text-sm font-medium text-gray-600">Payment Proof</span>
                  <span className="text-sm text-gray-800 font-mono">
                    {row.utrnumber ? (
                      row.utrnumber.slice(-10)
                    ) : row.fileUrl ? (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSecureDownload(row.fileUrl);
                        }}
                        className="text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0"
                      >
                        View Screenshot
                      </button>
                    ) : (
                      '-'
                    )}
                  </span>
                </div>

                {/* Transferred Amount */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-600">Transferred Amount</span>
                  <span className="text-sm text-gray-800 font-semibold">₹{row.transferredAmount}</span>
                </div>

                {/* Action Button */}
                <div className="flex justify-center gap-2 pt-3 mt-4 border-t border-gray-100">
                  {row.status === "Unassigned" ? (
                    <>
                      <Button
                        label="Approve Now"
                        onClick={() => {
                          setAssigningAgent(row);
                          setApprovalNote('');
                          setIsModalOpen(true);
                        }}
                        roundedButton
                        className="!bg-green-500 hover:!bg-green-600 !text-white rounded-full px-4 py-2 text-sm font-medium shadow-md transition-all"
                      />
                      <Button
                        label="Denied"
                        onClick={() => handleDeny(row)}
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-full text-sm font-medium shadow-md transition-all"
                        disabled={row.status === 'Denied'}
                      />
                    </>
                  ) : (
                    <Button
                      label="View Details"
                      onClick={() => {
                        setViewDetailsItem(row);
                        setViewDetailsModalOpen(true);
                      }}
                      className="text-blue-600 text-sm font-semibold hover:underline px-4 py-2"
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      ),
    },
  ];

  // Desktop columns - full table
  const desktopColumns = [
    {
      label: (
        <input
          type="checkbox"
          checked={isAllSelected}
          onChange={(e) => handleSelectAll(e.target.checked)}
          className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500"
        />
      ),
      key: "select",
      tdClassName: "text-center",
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedRows.includes(row.id || row._id)}
          onChange={(e) => handleRowSelection(row, e.target.checked)}
          className="w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded focus:ring-red-500"
        />
      ),
    },
    {
      label: "Requested By",
      key: "name",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.user?.username}</div>
          <div className="text-xs text-[#000000]">{row.user?.email}</div>
        </div>
      ),
    },
    { label: "Mobile Number", render: (row) => row.user?.mobileNo },
    {
      label: "Vehicle Class",
      key: "value",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img src={vehicleClassData?.tagimage} alt="Tag" className="w-[34px]" />
            <p>{vehicleClassData.value}</p>
            <div className="pl-2 flex items-center cursor-pointer" onClick={() => toggleVisibility(idx, item)}>
              {modalOpen && selectedIndex === idx ? (
                <Eye className="h-5 w-5" />
              ) : (
                <EyeOff className="h-5 w-5" />
              )}
            </div>
          </div>
        );
      },
    },
    { label: "Requested Date", render: (row) => moment(row.createdAt).format("DD MMMM, YYYY, hh:mm A"), },
    { label: "Quantity", key: "quantity" },
    {
      label: "Payment Proof",
      render: (row) => {
        if (row.utrnumber) return row.utrnumber.slice(-10);
        if (row.fileUrl) {
          return (
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleSecureDownload(row.fileUrl);
              }}
              className="text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0 font-medium whitespace-nowrap"
            >
              View Screenshot
            </button>
          );
        }
        return '-';
      }
    },
    { label: "Transferred Amount", key: "transferredAmount" },
    {
      label: "Action",
      key: "assign",
      tdClassName: "flex justify-end",
      render: (row) => (
        row.status === "Unassigned" ? (
          <div className="flex gap-2">
            <Button
              label="Approve Now"
              onClick={() => {
                setAssigningAgent(row);
                setApprovalNote('');
                setIsModalOpen(true);
              }}
              roundedButton
              className="!bg-green-500 hover:!bg-green-600 !text-white rounded-full px-3 py-2"
            />
            <Button
              label="Reject"
              onClick={() => handleDeny(row)}
              className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-full text-sm"
              disabled={row.status === 'Denied'}
            />
          </div>
        ) : (
          <button
            className="text-blue-600 text-sm font-semibold hover:underline px-4 py-2"
            onClick={() => {
              setViewDetailsItem(row);
              setViewDetailsModalOpen(true);
            }}
          >
            View Details
          </button>
        )
      ),
    },
  ];

  // Use different columns based on screen size
  const tableColumns = isMobile ? mobileColumns : desktopColumns;

  // Handle deny action
  const handleDeny = async (agent) => {
    if (window.confirm(`Are you sure you want to deny the request from ${agent.user?.username}?`)) {
      const data = {
        FasTagId: agent._id,
        status: "Rejected",
        remark: approvalNote
      };

      setCheckDeniedRequest(true);
      dispatch(ACTIONS.DeniedRequestAction(JSON.stringify(data)));
    }
  }

  // Watch for DeniedRequest response
  useEffect(() => {
    if (checkDeniedRequest && DeniedRequest) {
      if (DeniedRequest.status === 200 && DeniedRequest.success) {
        SuccessToast(DeniedRequest.message || 'Request denied successfully');
        getData(); // Refresh the data
      } else if (DeniedRequest.message) {
        ErrorToast(DeniedRequest.message);
      }
      setCheckDeniedRequest(false);
    }
  }, [DeniedRequest]);

  // Secure file download handler
  const handleSecureDownload = async (fileUrl) => {
    if (!fileUrl) {
      ErrorToast('No file URL available');
      return;
    }

    try {
      setIsDownloading(true);
      // Prepare the request body with the file URL
      const requestBody = JSON.stringify({
        InventoryExcleURL: fileUrl
      });

      // Call the secure download API
      const blob = await API.DownloadFile(requestBody);

      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;

      // Extract filename from URL or use a default name
      const urlParts = fileUrl.split('/');
      const filename = urlParts[urlParts.length - 1] || 'screenshot.jpg';
      link.download = filename;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the object URL
      window.URL.revokeObjectURL(downloadUrl);

      SuccessToast('File downloaded successfully');
    } catch (error) {
      console.error('Download failed:', error);
      ErrorToast('Failed to download file. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  }

  return (
    <>
      <Loading loading={isDownloading} fullScreen={true} overlay="true" />
      <div className="bg-white my-[30px]  rounded-xl p-4">
        <div className="flex items-center justify-between">
          <h2 className={titleClass}>{title}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-[21px]">
          {summaryStats.map((item, idx) => (
            <div key={idx} className="bg-white rounded-xl p-4 shadow-sm border flex items-center gap-4">
              <div className="w-14 h-14">
                <CircularProgressbar
                  value={item.percent}
                  text={`${item.percent % 1 === 0 ? item.percent : item.percent.toFixed(2)}%`}
                  styles={buildStyles({
                    pathColor: item.color,
                    textColor: "#000",
                    trailColor: "#e5e7eb",
                    textSize: "22px",
                  })}
                />
              </div>
              <div>
                <div className="text-lg font-semibold text-gray-900">{item.value.toLocaleString()}</div>
                <div className="text-sm text-gray-500">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>



      <div className="flex flex-col lg:flex-row md:justify-between md:items-center gap-4 mb-6">
        <div className="flex flex-col md:flex-row items-stretch lg:items-center gap-4 flex-1">
          <div className="relative w-full md:w-60">
            <TextInput
              name="serialNumber"
              placeholder="Mobile No. Vehicle Class"
              value={serialNumber}
              onChange={(e) => {
                setSerialNumber(e.target.value);
                setCurrentPage(1);
              }}
              inputClass="pl-5 pr-3 py-[12.5px] text-sm"
            />
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Search className="w-4 h-4" />
            </div>
          </div>
          {/* Distributor Dropdown using CustomSelectInput */}
          <div className="relative md:w-60 w-full ">
            <CustomSelectInput
              name="selectedAgent"
              label=""
              value={selectedAgent}
              onChange={(e) => {
                setSelectedAgent(e.target.value);
                setCurrentPage(1);
              }}
              options={[
                { name: "All Distributors", value: "" },
                ...distributorNames.map((name) => ({ name, value: name })),
              ]}
              inputClass="py-[12.5px] px-3 text-sm text-gray-500"
            />
          </div>
        </div>
        <div className="flex gap-2 w-full md:w-auto justify-center">
          <button
            onClick={() => {
              if (selectedRows.length === 0) {
                ErrorToast("Please select at least one request to approve");
                return;
              }
              setBulkApprovalNote('');
              setBulkModalOpen(true);
            }}
            disabled={selectedRows.length === 0}
            className={`py-[11px] rounded-full px-[25px] font-medium text-sm transition-colors ${selectedRows.length === 0
              ? 'bg-gray-400 cursor-not-allowed text-white'
              : 'bg-green-500 hover:bg-green-600 text-white'
              }`}
          >
            Bulk Approve {selectedRows.length > 0 ? `(${selectedRows.length})` : '+'}
          </button>
        </div>
      </div>

      {/* Single Approval Modal using AdminTableModal */}
      <AdminTableModal
        key={isModalOpen ? assigningAgent?._id || 'open' : 'closed'}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={`${assigningAgent?.user?.username} • Requested: ${assigningAgent?.quantity || 0} FASTags`}
        distributorName={assigningAgent?.user?.username}
        distributorId={assigningAgent?.user?._id}
        requestId={assigningAgent?._id}
        maxQuantity={assigningAgent?.quantity}
        reqVehicleClass={assigningAgent?.vehicleClass}
        mobile={assigningAgent?.user?.mobileNo}
        utr={assigningAgent?.utrnumber}
        date={moment(assigningAgent?.createdAt).format('DD MMM, YYYY')}
        fileUrl={assigningAgent?.fileUrl}
        showSearch={true}
      />

      {/* Bulk Approval Modal */}
      <CommonModal
        isOpen={bulkModalOpen}
        closeOnOutsideClick={false}
        onClose={() => setBulkModalOpen(false)}
        title={`Bulk Approve ${selectedRows.length} FASTag Requests`}
        size="max-w-4xl"
        footer={
          <div className="flex justify-end gap-4">
            <Button
              label="Cancel"
              onClick={() => setBulkModalOpen(false)}
              className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-4 py-2 rounded-md"
              disabled={isBulkApproving}
            />
            <Button
              label={isBulkApproving ? "Approving..." : "Approve All"}
              onClick={handleBulkApprove}
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md"
              disabled={isBulkApproving}
            />
          </div>
        }
      >
        <div className="space-y-4">
          {/* Summary */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold mb-2">Approval Summary</h3>
            <p className="text-sm text-gray-600">
              You are about to approve {selectedRows.length} FASTag requests.
            </p>
          </div>

          {/* Selected Requests List */}
          <div className="max-h-60 overflow-y-auto">
            <h4 className="text-md font-medium mb-3">Selected Requests:</h4>
            <div className="space-y-2">
              {getSelectedRowsData().map((row, index) => (
                <div key={row.id} className="bg-white border border-gray-200 rounded-lg p-3">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
                    <div>
                      <span className="font-medium text-gray-600">Name:</span>
                      <div className="text-gray-800">{row.user?.username}</div>
                    </div>
                    <div>
                      <span className="font-medium text-gray-600">Mobile:</span>
                      <div className="text-gray-800">{row.user?.mobileNo}</div>
                    </div>
                    <div>
                      <span className="font-medium text-gray-600">Vehicle Class:</span>
                      <div className="text-gray-800">{row.vehicleClass}</div>
                    </div>
                    <div>
                      <span className="font-medium text-gray-600">Transferred Amount:</span>
                      <div className="text-gray-800">₹{row.transferredAmount}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bulk Approval Note */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Bulk Approval Note (Optional)
            </label>
            <textarea
              placeholder="Enter remarks for all selected requests (optional)"
              value={bulkApprovalNote}
              onChange={(e) => setBulkApprovalNote(e.target.value)}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              rows="3"
            />
          </div>
        </div>
      </CommonModal>

      {/* View Details Side Modal */}
      {viewDetailsModalOpen && (
        <SideModal
          onClose={() => {
            setViewDetailsModalOpen(false);
            setViewDetailsItem(null);
          }}
          title={`FASTag Request Details: ${viewDetailsItem?.user?.username}`}
          setModalOpen={setViewDetailsModalOpen}
        >
          {viewDetailsItem && (
            <div className="space-y-4">
              {/* Request Information */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-gray-800">Request Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">Status:</span>
                    <div className="text-gray-800 font-medium">
                      <span className={`inline-block px-2 py-1 rounded-full text-xs ${viewDetailsItem.status === 'Assigned'
                          ? 'bg-green-100 text-green-800'
                          : viewDetailsItem.status === 'Rejected'
                            ? 'bg-red-100 text-red-800'
                            : 'bg-gray-100 text-gray-800'
                        }`}>
                        {viewDetailsItem.status}
                      </span>
                    </div>
                  </div>
                  {/* <div> */}
                  {/* <span className="text-sm font-medium text-gray-600">Request ID:</span>
                  <div className="text-gray-800 font-mono">{viewDetailsItem._id || viewDetailsItem.id}</div> */}
                  {/* </div> */}
                  <div>
                    <span className="text-sm font-medium text-gray-600">Vehicle Class:</span>
                    <div className="text-gray-800 font-medium">{viewDetailsItem.vehicleClass}</div>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">Requested Date:</span>
                    <div className="text-gray-800">{moment(viewDetailsItem.createdAt).format('DD MMMM, YYYY, hh:mm A')}</div>
                  </div>
                </div>
              </div>

              {/* User Information */}
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-blue-800">User Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">Name:</span>
                    <div className="text-gray-800 font-medium">{viewDetailsItem.user?.username}</div>
                  </div>
                  <div>
                    {/* <span className="text-sm font-medium text-gray-600">Email:</span>
                  <div className="text-gray-800">{viewDetailsItem.user?.email}</div> */}
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">Mobile Number:</span>
                    <div className="text-gray-800 font-mono">{viewDetailsItem.user?.mobileNo}</div>
                  </div>
                </div>
              </div>

              {/* Transaction Information */}
              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-green-800">Transaction Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm font-medium text-gray-600">Quantity:</span>
                    <div className="text-gray-800 font-semibold text-lg">{viewDetailsItem.quantity}</div>
                  </div>
                  <div>
                    <span className="text-sm font-medium text-gray-600">Total Amount:</span>
                    <div className="text-gray-800 font-semibold text-lg text-green-600">₹{viewDetailsItem.transferredAmount || 0}</div>
                  </div>
                  <div className="md:col-span-2">
                    <span className="text-sm font-medium text-gray-600">UTR Number:</span>
                    <div className="text-gray-800 font-mono bg-white p-2 rounded border">{viewDetailsItem.utrnumber}</div>
                  </div>
                  <label className="block text-sm font-medium text-gray-700 ">ScreenShorts :
                    <button
                      onClick={() => handleSecureDownload(viewDetailsItem?.fileUrl)}
                      className='text-blue-500 hover:text-blue-700 hover:underline cursor-pointer bg-transparent border-none p-0'
                      disabled={!viewDetailsItem?.fileUrl}
                    >
                      {viewDetailsItem?.fileUrl ? '  Download ' : ' No file available '}
                    </button>
                  </label>
                </div>
              </div>

              {/* Additional Details */}
              {((viewDetailsItem.remark && viewDetailsItem.remark.toLowerCase() !== 'assigned by admin') || viewDetailsItem.notes) && (
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h3 className="text-lg font-semibold mb-3 text-yellow-800">Additional Information</h3>
                  {(viewDetailsItem.remark && viewDetailsItem.remark.toLowerCase() !== 'assigned by admin') && (
                    <div className="mb-2">
                      <span className="text-sm font-medium text-gray-600">Remark:</span>
                      <div className="text-gray-800">{viewDetailsItem.remark}</div>
                    </div>
                  )}
                  {viewDetailsItem.notes && (
                    <div>
                      <span className="text-sm font-medium text-gray-600">Notes:</span>
                      <div className="text-gray-800">{viewDetailsItem.notes}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </SideModal>
      )}

      {/* Desktop Table */}
      <div className="hidden lg:block">
        <CommonTable
          isPagination={true}
          hideDateAndDownload={true}
          loading={checkGetFastag}
          columns={desktopColumns}
          data={tableData}
          emptyMessage="No Inventory Found"
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          selectedDate={selectedDate}
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
          setSelectedDate={setSelectedDate}
          tableData={tableData}
          total={GetFastag?.data?.pagination?.total}
          totalPages={Math.ceil(GetFastag?.data?.pagination?.total / itemsPerPage)}
        />
      </div>

      {/* Mobile Card Layout */}
      <div className="lg:hidden mb-[100px]" >
        {/* Mobile Pagination Header */}
        <div className="bg-white rounded-t-2xl shadow-sm p-4">
          {/* Top Row - Pagination and Show dropdown */}
          <div className="flex justify-center items-center mb-3 md:space-y-0 md:space-x-2">
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="text-red-500 disabled:text-gray-300"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <span className="text-sm text-gray-600">
                {(currentPage - 1) * itemsPerPage + 1}-
                {Math.min(currentPage * itemsPerPage, GetFastag?.data?.pagination?.total || 0)}
                <span className="text-gray-500"> of {GetFastag?.data?.pagination?.total || 0}</span>
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil((GetFastag?.data?.pagination?.total || 0) / itemsPerPage)))}
                disabled={currentPage === Math.ceil((GetFastag?.data?.pagination?.total || 0) / itemsPerPage)}
                className="text-red-500 disabled:text-gray-300"
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
            <div className="flex items-center space-x-1">
              <div className="flex items-center px-[20px]">
                <span className="text-sm text-gray-600">Show</span>

                <select
                  className="text-sm border border-gray-300 rounded px-2 py-1"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  {pageSizeOptions(GetFastag?.data?.pagination?.total || 0, itemsPerPage).map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

        </div>

        {/* Mobile Cards */}
        <div className="relative min-h-[150px]">
          <Loading loading={checkGetFastag} overlay={true} />
          {tableData.length === 0 ? (
            <div className="text-center font-bold text-red-500 bg-white py-10 rounded-lg shadow-sm">
              No Inventory Found
            </div>
          ) : (
            tableData.map((row, idx) => (
              <div key={idx}>
                {mobileColumns[0].render(row, idx)}
              </div>
            ))
          )}
        </div>
      </div>

      {/* Vehicle Class Modal */}
      {modalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setModalOpen(false);
              setSelectedClass({});
              setSelectedIndex(null);
            }
          }}
        >
          <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl max-h-[90vh] overflow-y-auto">
            <div className="p-4 md:p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    setSelectedClass({});
                    setSelectedIndex(null);
                  }}
                  className="text-gray-600 hover:text-red-500 p-1"
                >
                  <X size={18} className="md:w-5 md:h-5" />
                </button>
              </div>
              <h2 className="text-lg md:text-xl font-semibold mb-[4px] text-center pr-16">{vehicleData?.value}</h2>
              <p className="mb-[20px] md:mb-[30px] text-xs md:text-sm text-center px-2">{vehicleData?.description}</p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {show && <FastagPurchase onClose={() => setShow(false)} />}
    </>
  );
}

export default FastagRequest;
